
import React, { Component } from 'react';
import { connect } from "react-redux";

import { AD_MORE_TIME_CLICKED, AD_BONUS_CHANCE_VIDEO, AD_SHOW_HINT_CLICKED } from '../../utils/constants';
import { trackingWrapper } from '../../utils/analytics';
import IronSource from './IronSource';
import VideoOverlayJWPlayer from '../components/VideoOverlayJWPlayer';
import Newsletter from '../components/Newsletter';

const NAMESPACE = '[ RewardAdContainer ]';
export const RANDOM_END_RESULT_VIDEOS = 1;

class RewardAdContainer extends Component {

	constructor(props) {
		super(props);

		this.handleShowNewsletter = this.handleShowNewsletter.bind(this);
		this.handleWatchVideoInsteadClick = this.handleWatchVideoInstead.bind(this);

		this.state = {
			showNewsletter: true
		}
	}

	handleShowNewsletter(enable = true) {

		console.log('tracking: handleShowNewsletter', enable);
		this.setState({showNewsletter: enable});

		if (enable) {
			trackingWrapper('SSGame-newsletter');
		}
	}

	handleWatchVideoInstead() {
		this.handleShowNewsletter(false);
		trackingWrapper('SSGame-newsletter-watch-video-instead');
	}

	componentDidMount() {

		// componentDidMount() of child renders first before parent. setting the following will happen after FormContainer has been set
		// const { showNewsletter } = this.props;
		// this.handleShowNewsletter({showNewsletter});
	}

	componentDidUpdate(prevProps, prevState){

		const { showNewsletter } = this.state;

		// tracking

		let trackingTag = 'SSGame-replay-gate-ad';
		if (this.props.showVideoAd === AD_MORE_TIME_CLICKED){
			trackingTag = 'SSGame-more-time-ad';
		}	

		if (this.props.showVideoAd === AD_BONUS_CHANCE_VIDEO) {
			trackingTag = 'SSGame-bonus-chance-video-ad';
		}
	
		if (this.props.showVideoAd === AD_SHOW_HINT_CLICKED) {
			trackingTag = 'SSGame-hint-ad';
		}
		
		console.log('tracking: showNewsletter', prevState, this.state);
		if (showNewsletter === false && prevState.showNewsletter !== showNewsletter) {
			trackingWrapper(trackingTag);
		}

	}

	render(){

		const jwPlayerOverlay = (
			<VideoOverlayJWPlayer 
				showVideoAd={this.props.showVideoAd}
				handleVideoOverlayClose={this.props.handleVideoOverlayClose}
				videoAdType={this.props.trackingType}
			/>
		);

		if (this.state.showNewsletter) {
			return <Newsletter
				handleShowNewsletter={this.handleShowNewsletter}
				handleNewsletterSubmit={this.props.handleVideoOverlayClose}
				handleNewsletterClose={this.props.handleExitShowVideoAd}
				handleWatchVideoClick={this.handleWatchVideoInsteadClick}
				videoAdType={this.props.showVideoAd}
			/>

		}

		if (this.props.rewardVideo.ironRV.isReady() && this.props.rewardVideo.support === true) {

			return (
				<IronSource 
				showVideoAd={this.props.showVideoAd}
				handleVideoOverlayClose={this.props.handleVideoOverlayClose} 
				videoAdType={this.props.trackingType}
			/>
			)
		}

		return jwPlayerOverlay;
	}
}

const mapStateToProps = state => ({
  rewardVideo: state.rewardVideo
});

export default connect(
  mapStateToProps,
)(RewardAdContainer);